<template>
  <SoDialog
    v-model="value"
    :card-title="title"
    :loading="loading"
    :persistent="loading"
    :max-width="560"
    data-testid="banner-confirm-dialog"
  >
    <SoSimpleTable
      :headers="['Banner', 'Change']"
      :items="changes"
      class="mb-2 border rounded"
      data-testid="banner-confirm-changes"
    />
    <SoAlert
      v-for="note in notes"
      :key="note"
      type="info"
      :title="note"
      class="mt-2"
      data-testid="banner-confirm-note"
    />
    <SoCheckbox
      v-model="confirmed"
      label="I understand customers see these changes within about a minute"
      class="mt-6"
      data-testid="banner-confirm-checkbox"
    />
    <div class="d-flex justify-end mt-6">
      <SoButton
        title="Cancel"
        class="mr-2"
        large
        :disabled="loading"
        data-testid="banner-confirm-cancel"
        @click="value = false"
      />
      <SoButton
        title="Save"
        type="success"
        large
        :loading="loading"
        :disabled="!confirmed || loading"
        data-testid="banner-confirm-save"
        @click="$emit('confirm')"
      />
    </div>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import SoSimpleTable from "@/components/SoSimpleTable.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoCheckbox from "@/components/formControls/SoCheckbox.vue"

  export default defineComponent({
    components: { SoDialog, SoAlert, SoSimpleTable, SoButton, SoCheckbox },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        required: true,
      },
      changes: {
        type: Array as PropType<string[][]>,
        required: true,
      },
      notes: {
        type: Array as PropType<string[]>,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:modelValue", "confirm"],
    data() {
      return {
        confirmed: false,
      }
    },
    computed: {
      value: {
        get(): boolean {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
    watch: {
      modelValue(open: boolean) {
        if (open) this.confirmed = false
      },
    },
  })
</script>
